import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import queryString from 'query-string';

import Home from './routes/Home';
import Patron from './routes/Patron';
import Renew from './routes/Renew';
import Terms from './routes/Terms';
import Sync from './routes/Sync';
import Export from './routes/Export';

import { Template } from './models/Template';
import { FormTemplate } from 'form-builder'

function App() {

    const runOnceOnStartup = () => {
        Template.registerButtonActions();
        Template.registerCustomFields();
    };

    
    useEffect(() => {
        runOnceOnStartup();
    }, []); // runs once on initial mount of App component


    return (
        <div className="App">
        <CookiesProvider>
            <Router>
                <Switch>

                    <Route path='/' exact={true} render={ () => {
                        return <Redirect to="/agportal"/>;
                    }}/>
                
                    <Route path='/patron' exact={true} render={ (props) => {
                        let query = queryString.parse(props.location.search);
                        const fieldParams = FormTemplate.getFieldParams(props.location.search);

                        //Arrive to Patron portal, potentially with a group name, a testing key, support flag, and an original Application ID
                        return <Patron group={query.group} test={query.test} alternate={query.support} origApplicationID={query.origID} 
                                       email={query.email} paper={query.paper} fieldParams={fieldParams} renewalMembershipID={query.renewID}
                                       renewHmac={query.renewHmac}/>; 
                        
                    }}/>

                    <Route path='/patron/renew' exact={true} render={ (props) => {
                        let query = queryString.parse(props.location.search);

                        //Arrive to Renewal portal, with a group name and potentially a testing key
                        return <Renew group={query.group} test={query.test}/>; 
                        
                    }}/>

                    <Route path='/community' exact={true} render={ (props) => {
                        let query = queryString.parse(props.location.search);
                        const fieldParams = FormTemplate.getFieldParams(props.location.search);
                        
                        //Arrive to Community portal, potentially with a group name, a testing key, and an original Application ID
                        //This is the internal Community support form, we're going to re-use the Patron portal with a flag
                        return <Patron group={query.group} test={query.test} origApplicationID={query.origID} email={query.email} internal={true} fieldParams={fieldParams}/>; 
                        
                    }}/>
                    
                    <Route path='/patron/terms' exact={true} component={Terms}/>     
                        
                    <Route path='/agportal' exact={true} render={ (props) => {
                        let query = queryString.parse(props.location.search);
                        
                        return <Home id={query.id}/>;  //arrive to Access Granted portal, potentially with an id
                        
                    }}/>
                            
                    <Route path='/agportal/sync' exact={true} render={ (props) => {
                        let query = queryString.parse(props.location.search);
                        
                        return <Sync id={query.id} group={query.group} support={query.support}/>;  //Go to PP Sync Route with an application id, group, and support flag
                        
                    }}/>

                    <Route path='/agportal/export' exact={true} render={ (props) => {
                        let query = queryString.parse(props.location.search);
                        
                        return <Export id={query.id}/>;  //Go to Export Route with an export job id
                        
                    }}/>


                </Switch>
            </Router>
        </CookiesProvider>
        </div>
    );
}

export default App;


//Use this to send to an external website (safely!) in a new tab
export function ExternalLink(props) {
    
    return <a href={props.href} target="_blank" rel="noopener noreferrer">{props.target}</a>;
    
}


//Returns a normalized http(s) or mailto url, or null if unsafe (blocks javascript:, data:, etc.)
function toSafeUrl(url) {
    try {
        const parsed = new URL(url, window.location.origin);
        if (parsed.protocol === 'http:' || parsed.protocol === 'https:' || parsed.protocol === 'mailto:') {
            return parsed.href;
        }
    } catch (e) {
        // malformed url
    }
    console.warn('Blocked unsafe url');
    return null;
}


//Opens only http(s) urls in a new tab, without exposing window.opener
export function OpenInNewTab(url) {
    const safeUrl = toSafeUrl(url);
    if (safeUrl) {
        window.open(safeUrl, '_blank', 'noopener,noreferrer');
    }
}


//Opens only http(s) urls in the current tab
export function OpenInSameTab(url) {
    const safeUrl = toSafeUrl(url);
    if (safeUrl) {
        window.location.assign(safeUrl);
    }
}
